import React from 'react';
export const TranslationsContext = React.createContext({ t: (s) => s });
//# sourceMappingURL=translations-context.js.map